// ต้องตรงกับ backend/modules/announcement/announcement.constants.js
export const CATEGORY_OPTIONS = [
  { value: 'general', label: 'HR / ทั่วไป', color: '#2563eb', hint: 'วันหยุด, นโยบายใหม่, กฎการเบิกจ่าย, กำหนดส่งเอกสาร' },
  { value: 'payroll', label: 'เงินเดือน / บัญชี', color: '#059669', hint: 'วันตัดรอบ, วันเงินเดือนออก, ปิดงบเดือน' },
  { value: 'safety', label: 'ความปลอดภัยหน้างาน', color: '#ea580c', hint: 'กฎ PPE, อุบัติเหตุ, สภาพอากาศไม่เหมาะทำงาน' },
];

export const PRIORITY_OPTIONS = [
  { value: 'normal', label: 'ปกติ', color: 'default', hint: 'กดปิดได้เลย (นับว่ารับทราบ)' },
  { value: 'important', label: 'สำคัญ', color: 'warning', hint: 'มีปุ่ม "รับทราบ" แยก ปิดไปก่อนได้' },
  { value: 'critical', label: 'วิกฤต', color: 'error', hint: 'เด่นที่สุด ต้องกด "รับทราบ" ก่อนถึงปิดได้' },
];

export const AUDIENCE_OPTIONS = [
  { value: 'all', label: 'พนักงานทุกคน' },
  { value: 'department', label: 'เฉพาะแผนก' },
  { value: 'role', label: 'เฉพาะบทบาท' },
];

export const findOption = (options, value) => options.find((o) => o.value === value) || options[0];

export const fmtDateTime = (v) => (v
  ? new Date(v).toLocaleString('th-TH', {
    day: 'numeric', month: 'short', year: '2-digit', hour: '2-digit', minute: '2-digit',
  })
  : '-');

export const fmtDate = (v) => (v
  ? new Date(v).toLocaleDateString('th-TH', { day: 'numeric', month: 'short', year: '2-digit' })
  : '-');
